// extracted by mini-css-extract-plugin
export var article = "offer-styles-module--article--d5663";
export var bigText = "offer-styles-module--big-text--0d1f5";
export var faqSection = "offer-styles-module--faq-section--31320";
export var inner = "offer-styles-module--inner--36463";
export var richText = "offer-styles-module--rich-text--a161c";
export var text = "offer-styles-module--text--7b54c";
export var verticalImage = "offer-styles-module--vertical-image--e7920";
export var verticalPictureSection = "offer-styles-module--vertical-picture-section--6f61d";
export var wrapper = "offer-styles-module--wrapper--5d7c9";